import React, {useRef} from 'react';
import styled from 'styled-components';
import * as F from '../../lib/util/CommonFunctions';
import {isMobileOnly} from 'react-device-detect';
import { FormatNumber, showAmount } from '../../lib/util/CommonFunctions';
const ChartBlock = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 100px;
`;
const SummaryBlock = styled.tfoot`

`;
const MobileSummaryBlock = styled.div`
      
      .summary {
        display: flex;
        flex-direction: column;
        border: 2px solid #111;
        .header {
          padding:10px;
          background-color: #ececec;
          font-weight: 600;
        }
        .body {
            margin: 10px 0;
            &>div {
              display: flex;
              justify-content: space-between;
              padding:5px 10px;              
            }        
        }
        .symbol {
          height: 2px;
          position: relative;
          border: 1px solid #111;
          button {
            border-radius: 50%;
            position: absolute;
            border: 2px solid #111;
            background-color: #fff;
            width: 30px;
            height: 30px;
            padding: 5px;
            top: -15px;
            left: 50%;
            margin-left: -15px;          
          }          
        }        
        .footer-summary {
          padding:10px;
          color:#fff;
          background-color: #111;
          font-weight:700;
          font-size: 1.1em;
          display: flex;
          justify-content: space-between;        
        }
      }      
      .desired-amount {
        display: flex;
        justify-content: flex-end;        
        padding: 10px 5px;
      }          
`;
/*
* 견적서 상품견적 합계 표시하는 공통 컴포넌트
* */
const EsComSummary = (props) => {
  const summaries = {
    equation:(item) =>
      <ChartBlock>
          <ul className="esd_info-list clearfix">
            <li className="plus-icon flex dcol jcc">
              <div className="esd_cate">총 상품 금액</div>
              {F.showAmount({amount:item.es_prdct_total_price, fontSize:"30px", weight:"700", unit:"원"})}
            </li>
            <li className="plus-icon flex dcol jcc">
              <div className="esd_cate">총 할인 금액</div>
              {F.showAmount({amount:item.es_dscnt_total_price, fontSize:"30px", weight:"700", prefix:"-", color:"#fc1c67", unit:"원"})}
            </li>
            <li className="equal-icon flex dcol jcc">
              <div className="esd_cate">총 배송비</div>
              {F.showAmount({amount:item.es_dlvry_total_price, fontSize:"30px", weight:"700", unit:"원", falseVal: "무료 배송", fvWeight:"500" })}
              {item.es_detail_dlvry_pay_type === '025202'&&<div className="esd_info">(착불 배송비)</div>}
            </li>
            <li className="value flex dcol jcc">
              <div className="esd_cate">총 견적 금액</div>
              {F.showAmount({amount:item.es_pay_price, fontSize:"40px", weight:"700", unit:"원"})}
              {item.es_detail_dlvry_pay_type === '025202'&&<div className="esd_info">(배송비 별도)</div>}
            </li>
          </ul>
        </ChartBlock>
    ,
    responsive:(item) =>
        <MobileSummaryBlock>
          <div className="summary">
            {!!item.es_pay_price?
              <>
                <div className="header">최종 견적 금액</div>
                <div className="body">
                  <div>
                    <div>총 상품금액</div>
                    <div>{showAmount({ amount: item.es_prdct_total_price, unit:"원" })}</div>
                  </div>
                  <div>
                    <div>배송비</div>
                    <div>{showAmount({ amount: item.es_dlvry_total_price, unit:"원"})}</div>
                  </div>
                </div>
                <div className="symbol">
                  <button>< i className="fas fa-minus"/></button>
                </div>
                <div className="header">할인 금액</div>
                <div className="body">
                  <div>
                    <div>할인 금액</div>
                    <div className="discount">{showAmount({ amount: item.es_dscnt_total_price, color:"#fc1c67", prefix:"-", unit:"원" })}</div>
                  </div>
                  <div>
                    <div>추가 할인금액</div>
                    <div className="discount">{showAmount({ amount: item.es_add_dscnt_price_total, color:"#fc1c67", prefix:"-", unit:"원"})}</div>
                  </div>
                </div>
                <div className="symbol">
                  <button>< i className="fas fa-equals"/></button>
                </div>
                <div className="footer-summary">
                  <div>총 견적금액</div>
                  <div>{showAmount({ amount: item.es_pay_price, color:"#fff", unit:"원" })}</div>
                </div>
              </>
              :
              <>
                <div className="header">총 상품금액</div>
                <div className="body">
                    <div>
                      <div>총 수량</div>
                      <div>{showAmount({ amount: item.total_qty, unit:"개"})}</div>
                    </div>
                  <div>
                    <div>총 상품금액</div>
                    <div>{showAmount({ amount: item.es_prdct_total_price, unit:"원" })}</div>
                  </div>
                  </div>
              </>
            }
          </div>
          {desiredAmount[props.type](item)}
        </MobileSummaryBlock>
     ,
    tableTr:(item) =>
        <tfoot>
        <tr className={item.es_pay_price?'total-pay_tr':''}>
          {!item.es_pay_price&&
              <td colSpan="2" className="mint text_center"/>
          }
          <td className="mint text_center">
            총 수량 <span className="font-mont">{item.total_qty}</span>개
          </td>
          <td className="mint text_center">
            <div className={item.es_pay_price&&'minus-icon'}>
              {showAmount({ amount: item.es_prdct_total_price, unit:"원", fontSize: item.es_pay_price?"14px":"20px" , weight:"700", unitWeight:"500"})}
            </div>
          </td>
          {!!item.es_pay_price&&
            <React.Fragment>
              <td className="mint text_center">
                <div className="total-pay plus-icon">
                  {showAmount({ amount: item.es_dscnt_total_price, unit:"원", fontSize:"14px", weight:"700", color:"#fc1c67", unitWeight:"500"})}
                </div>
              </td>
              <td className="mint text_center">
                <div className="total-pay equal-icon">
                  {item.es_detail_dlvry_pay_type === '025202'&&<div className="total-absolute fontsize-14 gray-text">착불 배송비</div>}
                  {showAmount({ amount: item.es_dlvry_total_price, unit:"원", fontSize:"15px", falseVal: "무료 배송", fvWeight:"500"})}
                </div>
              </td>
              <td className="mint text_center">
                <div className="total-pay">
                  {showAmount({ amount: item.es_pay_price, unit:"원", fontSize:"20px", weight:'700', unitWeight:"500"})}
                </div>
              </td>
            </React.Fragment>
          }
        </tr>
        {desiredAmount[props.type](item)}
        </tfoot>
  }

  const desiredAmount = {
    responsive:(item)=>
      <div className="desired-amount">
        {showAmount({
          prefix: '희망 견적 금액: ',
          fontSize: '0.9em',
          weight: 'bold',
          amount: item.rqst_price,
          falseVal: '-',
          unit: '원',
        })}
      </div>
    ,
    tableTr:(item)=><tr>
      <td colSpan={item.es_pay_price?'3':'2'}/>
      <td colSpan="2" className="hope_pay text_center">
        {showAmount({
          prefix: "희망 견적 금액: ",
          fontSize: "15px",
          weight: "500",
          amount: item.rqst_price,
          unit:"원",
          color:"#666",
          pfMarginRight:"10px",
        })}
      </td>
    </tr>
  }

  return(summaries[props.type](props.item))
}

export default EsComSummary;
